// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hP2tm","content":"styles_content__Lmosp","tableWrap":"styles_tableWrap__1NJAx"};